export { default } from './Loader.jsx'



// WEBPACK FOOTER //
// ./src/components/common/Loader/index.js